export const ratingValue = 4
export const iconUrl = 'images/motos/logos/logo-motos-small.svg'
export const storeUrl = {
  android: 'https://motos.onelink.me/2186615092/ff9197bb',
  ios: 'https://play.google.com/store/apps/details?id=motos.net&hl=es'
}

export const IS_SMARTBANNER_APPSFLYER_ENABLED = false

export const SMARTBANNER_COOLDOWN_HOURS = {
  DEFAULT: 24,
  AFTER_INSTALL_CLICK: 48
}

const SMARTBANNER_SOURCE_ID_DEFAULT = 'default'
const SMARTBANNER_SOURCE_ID_HOME = 'home'
const SMARTBANNER_SOURCE_ID_ADS_LIST = 'ads_list'
const SMARTBANNER_SOURCE_ID_ADS_DETAIL = 'ads_detail'
const SMARTBANNER_SOURCE_ID_EDITORIAL = 'editorial'

export const SMARTBANNER_SOURCE_IDS = {
  DEFAULT: SMARTBANNER_SOURCE_ID_DEFAULT,
  HOME: SMARTBANNER_SOURCE_ID_HOME,
  ADS_LIST: SMARTBANNER_SOURCE_ID_ADS_LIST,
  ADS_DETAIL: SMARTBANNER_SOURCE_ID_ADS_DETAIL,
  EDITORIAL: SMARTBANNER_SOURCE_ID_EDITORIAL
}

export const SMARTBANNER_SOURCES = {
  [SMARTBANNER_SOURCE_ID_DEFAULT]: {
    title: 'SMARTBANNER.DEFAULT.TITLE_MOTOS',
    description: 'SMARTBANNER.DEFAULT.DESCRIPTION_MOTOS',
    ctaColor: 'ACCENT',
    ctaText: 'SMARTBANNER.CTA'
  },
  [SMARTBANNER_SOURCE_ID_HOME]: {
    title: 'SMARTBANNER.HOME.TITLE_MOTOS',
    description: 'SMARTBANNER.HOME.DESCRIPTION_MOTOS',
    ctaColor: 'ACCENT',
    ctaText: 'SMARTBANNER.CTA'
  },
  [SMARTBANNER_SOURCE_ID_ADS_LIST]: {
    title: 'SMARTBANNER.ADS_LIST.TITLE_MOTOS',
    description: 'SMARTBANNER.ADS_LIST.DESCRIPTION_MOTOS',
    ctaColor: 'ACCENT',
    ctaText: 'SMARTBANNER.CTA_INSTALL'
  },
  [SMARTBANNER_SOURCE_ID_ADS_DETAIL]: {
    title: 'SMARTBANNER.ADS_DETAIL.TITLE_MOTOS',
    description: 'SMARTBANNER.ADS_DETAIL.DESCRIPTION_MOTOS',
    ctaColor: 'PRIMARY',
    ctaText: 'SMARTBANNER.CTA_INSTALL'
  },
  [SMARTBANNER_SOURCE_ID_EDITORIAL]: {
    title: 'SMARTBANNER.EDITORIAL.TITLE_MOTOS',
    description: 'SMARTBANNER.EDITORIAL.DESCRIPTION_MOTOS',
    ctaColor: 'ACCENT',
    ctaText: 'SMARTBANNER.CTA'
  }
}
